import { Button } from "../../../generics/button";
import errorIcon from "../../../../assets/icons/error.svg";
import { useModal } from "../../../../hooks/ModalContext";

export const ErroAcordo = () => {
  const { onClose } = useModal();
  return (
    <>
      <div className="flex flex-col items-center p-1">
        <img src={errorIcon} alt="" className="-mt-4 h-20 w-20" />
        <p className="my-4 text-center text-lg text-gray-600">
          Ocorreu uma inconsistência na geração do seu boleto!
        </p>
        <Button name="Confirmar" onClick={() => onClose()} />
      </div>
    </>
  );
};
